function adjustWidthToParent(elm) {
    var child = $(elm);
    var parentwidth = $(elm).parent().width();
    child.width(parentwidth);
}

var magazineBody;

$(document).ready(function () {
    magazineBody = $('.contentheader-magazine-body');
    adjustWidthToParent(magazineBody);
});

$(window).resize(function () {
    adjustWidthToParent(magazineBody);
});
